function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{},this.size=0}var nativeCreate=require("./_nativeCreate");module.exports=hashClear;